<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Force Check Out Utility -Front
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Date</label>
            </div>
            <div class="col-md-3 px-1">
                <div class="input-group">
                    <input class="form-control" placeholder="yyyy-mm-dd" name="HolidayDate" placeholder="Ex. DD/MM/YYYY"
                        [(ngModel)]="ForceDate" #HolidayDate="ngModel" ngbDatepicker #d="ngbDatepicker"
                        [ngModelOptions]="{standalone: true}" required  readonly/>
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"
                        type="button"></button>
                    <div class="invalid-feedback">
                        Please enter date !
                    </div>
                </div>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Branch </label>
            </div>
            <div class="col-md-4 px-1">
                <ng-select [items]="BranchMaster" [multiple]="true" bindLabel="BranchName" name="muliex"
                    [selectableGroup]="false" [selectableGroupAsModel]="false" [closeOnSelect]="false"
                    bindValue="BranchMasterID" [(ngModel)]="BranchMasterIDs" placeholder="Select Branch" required>

                    <ng-template ng-header-tmp let-items="items">
                        <input type="checkbox" (change)="CheckAll($event,'Branch')" /> Check All
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                            [ngModelOptions]="{ standalone : true }" />
                        {{item.BranchName}}
                    </ng-template>
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                            <span class="ng-value-label">{{item.BranchName}}</span>
                        </div>
                        <div class="ng-value" *ngIf="items.length > 1">
                            <span class="ng-value-label">{{items.length - 1}} +...</span>
                        </div>
                    </ng-template>
                </ng-select>
                <div class="invalid-feedback">
                    Please select Branch.
                </div>
            </div>

            <div class="col-md-2 px-1">
                <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="submit" (click)="Load()">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Cancel':'Loading...'}}</button>
        </div>
    </div>
</div>